import React, { useState } from 'react';
import { Button, Typography } from 'antd';
import { Container } from '@/ui';
import { DocumentLine, UploadDocumentsBox } from '@/components';
import { API_URL } from '@/utils/static';

export const ProductFileDownloads = ({
  product,
  files,
  setFiles,
  onDeleteFile,
  onUploadFiles,
  t
}) => {
  const [documentName, setDocumentName] = useState(null);

  if (!product?.id) return null;

  return (
    <Container $paddingBottom={10}>
      {product.productFileToDownloads && product.productFileToDownloads.length > 0 && (
        <>
          <Typography.Title level={4}>{t('Files')}</Typography.Title>
          <Container $marginLeft={15} $marginBottom={20}>
            {product.productFileToDownloads.map((file, index) => (
              <DocumentLine
                key={file.id}
                doc={{
                  name: file.name ?? 'Untitled',
                  documentURL: `${API_URL}/${file.fileURL}`,
                  id: file.id
                }}
                withRename
                onDelete={() => onDeleteFile(file.id)}
                index={index + 1}
              />
            ))}
          </Container>
        </>
      )}
      <Container>
        <Typography.Title level={5} style={{ marginBottom: '15px' }}>
          {t('Upload new files')}
        </Typography.Title>

        <UploadDocumentsBox
          docs={files}
          setDocs={setFiles}
          buttonProps={{
            label: files.length > 0 ? t('Choose more files') : t('Choose files')
          }}
          multiple
          withInput
          hideLastBorder
          documentName={documentName}
          setDocumentName={setDocumentName}
        />
        <Container $marginTop={20}>
          <Button
            onClick={() => onUploadFiles(documentName)}
            disabled={files.length === 0}
            type='primary'
          >
            {t('Upload files')}
          </Button>
        </Container>
      </Container>
    </Container>
  );
};
